// extracted by mini-css-extract-plugin
export default {"tabs":"EdgeDistribution_tabs__OLNLC","wrapper":"EdgeDistribution_wrapper__PzrzG","row":"EdgeDistribution_row__EeKNF"};